// //for IE, Edge polyfill
import smoothscroll from 'smoothscroll-polyfill';
import objectFitImages from 'object-fit-images';
import ScrollOut from "scroll-out";

smoothscroll.polyfill();
objectFitImages();

//load web fonts
import './_fonts.js';
import './_global-nav.js';
import './_form.js';

function setScrollOut(){

  ScrollOut();

  ScrollOut({
    targets: "body, .site-header",
    offset: 400
  });

}
setScrollOut();
